
export default function CoreTruthsSection() {
  const truths = [
    {
      icon: 'ri-heart-pulse-line',
      title: 'Protecting the Patient',
      description: 'Data security is a patient safety issue. If the data is compromised, care is compromised. We ensure that every system, every login, and every piece of patient information is protected with the same care you provide to your patients.',
    },
    {
      icon: 'ri-shield-user-line',
      title: 'Protecting the Employee',
      description: 'We shield your staff from the consequences of accidental clicks. We provide the training and tools that keep them safe from the "business-ending" mistakes. Your team deserves to work confidently, knowing they\'re protected.',
    },
    {
      icon: 'ri-building-2-line',
      title: 'Protecting the Business',
      description: 'We treat IT as a foundational asset. We are there to ensure that the business you built isn\'t erased by a single cyber event. Your practice represents years of dedication—we make sure it stays secure and thriving.',
    },
  ];

  return (
    <section className="py-24 bg-gradient-to-br from-gray-900 via-slate-800 to-gray-900">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block">
            <h2 className="text-5xl font-bold text-white mb-4">Our Core Commitment</h2>
            <div className="h-1 w-20 bg-[#e10708] mx-auto"></div>
          </div>
          <p className="text-xl text-gray-300 mt-6 max-w-3xl mx-auto">
            Three fundamental principles guide everything we do
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-12">
          {truths.map((truth, index) => (
            <div key={index} className="text-center group">
              <div className="relative mb-6">
                <div className="w-24 h-24 mx-auto bg-[#e10708]/10 rounded-full border-2 border-[#e10708] flex items-center justify-center group-hover:bg-[#e10708]/20 transition-all duration-300">
                  <i className={`${truth.icon} text-[#e10708] text-4xl`}></i>
                </div>
                <div className="h-16 w-0.5 bg-[#e10708]/30 mx-auto mt-4"></div>
              </div>
              <h3 className="text-2xl font-bold text-white mb-4">{truth.title}</h3>
              <p className="text-gray-300 leading-relaxed">{truth.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
